<!-- MODAL addEditMaquina -->
<div mdbModal #addEditMaquina="mdb-modal" class="modal fade modalAddEdit" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel" *ngIf="mode === 'ADD'">
          Agregar máquina
        </h4>
        <h4 class="modal-title w-100 text-left" id="myModalLabel" *ngIf="mode === 'EDIT'">
          Editar máquina
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="addEditMaquina.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <form autocomplete="off" [formGroup]="formHeader">
        <div class="modal-body">
          <div class="row">
            <div class="col">
              <h5 class="modal-title w-100 text-left" id="myModalLabel">
                Datos de la máquina
              </h5>
            </div>
            <!-- <div class="col">
                            <div class="switch info-switch">
                                <label>Inactivo<input class="form-check-input" type="checkbox" id="activo"
                                        formControlName="activo" />
                                    <span class="lever"></span>Activo</label>
                            </div>
                        </div> -->

            <div class="col" style="max-width: 300px">
              <div class="md-form mb-0">
                <mdb-select [options]="optionsTipoDestinatario" [multiple]="false" [filterEnabled]="true"
                  [highlightFirst]="false" placeholder="Seleccionar Ubicación" formControlName="tipoDestinatario">
                </mdb-select>
                <label>Ubicación</label>
                <div *ngIf="
                                    formHeader.get('tipoDestinatario').invalid &&
                                    (formHeader.get('tipoDestinatario').dirty ||
                                    formHeader.get('tipoDestinatario').touched)
                                    ">
                  <mdb-error *ngIf="formHeader.get('tipoDestinatario').hasError('required')">
                    Ingrese Ubicación
                  </mdb-error>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col">
              <div class="md-form mb-0">
                <input value="" type="text" id="nPlaca" class="form-control" placeholder="1231FG" required #nPlaca
                  formControlName="nroPlaca" disabled />
                <label for="nPlaca">N° Placa</label>
                <div *ngIf="
                                    formHeader.get('nroPlaca').invalid &&
                                    (formHeader.get('nroPlaca').dirty ||
                                    formHeader.get('nroPlaca').touched)
                                    ">
                  <mdb-error *ngIf="formHeader.get('nroPlaca').hasError('required')">
                    Ingrese n° placa
                  </mdb-error>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="md-form mb-0">
                <input value="" type="text" id="marca" class="form-control" placeholder="Marca" required #marca
                  formControlName="marca" />
                <label for="marca">Marca</label>
                <div *ngIf="
                                    formHeader.get('marca').invalid &&
                                    (formHeader.get('marca').dirty ||
                                    formHeader.get('marca').touched)
                                    ">
                  <mdb-error *ngIf="formHeader.get('marca').hasError('required')">
                    Ingrese marca
                  </mdb-error>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="md-form mb-0">
                <input value="" type="text" id="modelo" class="form-control" placeholder="Modelo" required #modelo
                  formControlName="modelo" />
                <label for="modelo">Modelo</label>
                <div *ngIf="
                                    formHeader.get('modelo').invalid &&
                                    (formHeader.get('modelo').dirty ||
                                    formHeader.get('modelo').touched)
                                    ">
                  <mdb-error *ngIf="formHeader.get('modelo').hasError('required')">
                    Ingrese modelo
                  </mdb-error>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col" style="max-width: 300px">
              <div class="md-form mb-0">
                <mdb-select [options]="optionsFamilia" [multiple]="false" [filterEnabled]="true"
                  [highlightFirst]="false" placeholder="Seleccionar Familia" formControlName="familia"></mdb-select>
                <label>Familia</label>
                <div *ngIf="
                                    formHeader.get('familia').invalid &&
                                    (formHeader.get('familia').dirty ||
                                    formHeader.get('familia').touched)
                                    ">
                  <mdb-error *ngIf="formHeader.get('familia').hasError('required')">
                    Ingrese familia
                  </mdb-error>
                </div>
              </div>
            </div>
            <div class="col" style="max-width: 300px">
              <div class="md-form mb-0">
                <mdb-select [options]="optionsGrupo" [multiple]="false" [filterEnabled]="true" [highlightFirst]="false"
                  placeholder="Seleccionar Grupo" formControlName="grupo">
                </mdb-select>
                <label>Grupo</label>
                <div *ngIf="
                                    formHeader.get('grupo').invalid &&
                                    (formHeader.get('grupo').dirty ||
                                    formHeader.get('grupo').touched)
                                    ">
                  <mdb-error *ngIf="formHeader.get('grupo').hasError('required')">
                    Ingrese grupo
                  </mdb-error>
                </div>
              </div>
            </div>
            <div class="col" style="max-width: 300px">
              <div class="md-form mb-0">
                <mdb-select [options]="optionsEstado" [multiple]="false" [filterEnabled]="true" [highlightFirst]="false"
                  placeholder="Seleccionar Estado" formControlName="estado">
                </mdb-select>
                <label>Estado</label>
                <div *ngIf="
                                    formHeader.get('estado').invalid &&
                                    (formHeader.get('estado').dirty ||
                                    formHeader.get('estado').touched)
                                    ">
                  <mdb-error *ngIf="formHeader.get('estado').hasError('required')">
                    Ingrese estado
                  </mdb-error>
                </div>
              </div>
            </div>

            <div class="col" style="max-width: 300px">
              <div class="md-form mb-0">
                <mdb-select [options]="optionsRubro" placeholder="Seleccionar Rubro" [filterEnabled]="true"
                  formControlName="RubroSel" [disabled]="movCerrado == true"></mdb-select>
                <label>Rubro</label>
                <div *ngIf="
                                  formHeader.get('RubroSel').invalid &&
                                  (formHeader.get('RubroSel').dirty ||
                                  formHeader.get('RubroSel').touched)
                                  ">
                  <mdb-error *ngIf="formHeader.get('RubroSel').hasError('required')">
                    Ingrese rubro
                  </mdb-error>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col" style="max-width: 200px">
              <div class="md-form">
                <input value="" type="text" id="rutProveedor" class="form-control" placeholder="99.999.999-9" required
                  #rutProveedor formControlName="rutProveedor" formatRut />
                <label for="rutproveedor">Rut proveedor</label>
                <div *ngIf="
                                    formHeader.get('rutProveedor').invalid &&
                                    (formHeader.get('rutProveedor').dirty ||
                                    formHeader.get('rutProveedor').touched)
                                    ">
                  <mdb-error *ngIf="formHeader.get('rutProveedor').hasError('required')">
                    Ingrese rut proveedor
                  </mdb-error>
                </div>
              </div>
            </div>
            <div class="col d-flex" style="max-width: 400px">
              <button mdbBtn type="button" class="btn-cuadrado" [disabled]="buttonLoad == true" color="secondary"
                mdbWavesEffect (click)="abrirModalSeleccionarProveedor()">
                <mdb-icon fas icon="search"></mdb-icon>
              </button>
              <h6 class="text-info" style="display: contents" *ngIf="proveedorSeleccionado">
                {{ proveedorSeleccionado.nombre}}
              </h6>
            </div>
            <div class="col" style="max-width: 200px">
              <div class="md-form mb-0">
                <mdb-date-picker [inline]="true" #dpFechaMain name="fechaMain" [placeholder]="'Fecha'" required
                  formControlName="fechaMain">
                </mdb-date-picker>
                <div *ngIf="
                                    formHeader.get('fechaMain').invalid &&
                                    (formHeader.get('fechaMain').dirty ||
                                    formHeader.get('fechaMain').touched)
                                    ">
                  <mdb-error *ngIf="formHeader.get('fechaMain').hasError('required')">
                    Ingrese fecha
                  </mdb-error>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col">
              <div class="md-form mb-0">
                <input value="" type="text" id="observacion" class="form-control" placeholder="Observación..."
                  #observacion formControlName="observacion" />
                <label for="observacion">Observación</label>
                <!-- <div *ngIf="
                                    formHeader.get('observacion').invalid &&
                                    (formHeader.get('observacion').dirty ||
                                    formHeader.get('observacion').touched)
                                    ">
                                    <mdb-error *ngIf="formHeader.get('observacion').hasError('required')">
                                        Ingrese observación
                                    </mdb-error>
                                </div> -->
              </div>
            </div>
          </div>



          <div class="row mt-2">
            <div class="col">
              <div class="md-form mb-0">
                <h5 class="mt-2" style="border-bottom: 1px solid #dee2e6">
                  Detalle de la compra
                </h5>

              </div>
            </div>
          </div>

          <div class="row">
            <div class="col" style="max-width: 300px">
              <div class="md-form mb-0">
                <mdb-select [options]="optionsTipoDoc" [multiple]="false" [filterEnabled]="false"
                  [highlightFirst]="false" placeholder="Guía de despacho" formControlName="tipoDte">
                </mdb-select>
                <label>Tipo de documento</label>
                <div *ngIf="
                                    formHeader.get('tipoDte').invalid &&
                                    (formHeader.get('tipoDte').dirty ||
                                    formHeader.get('tipoDte').touched)
                                    ">
                  <mdb-error *ngIf="formHeader.get('tipoDte').hasError('required')">
                    Ingrese tipo documento
                  </mdb-error>
                </div>
              </div>
            </div>
            <div class="col" style="max-width: 300px">
              <div class="md-form mb-0">
                <input value="" type="text" id="ndoc" class="form-control" placeholder="N° Documento" #ndoc
                  formControlName="nroDoc" />
                <label for="ndoc">N° Documento</label>
                <!-- <div *ngIf="
                                    formHeader.get('nroDoc').invalid &&
                                    (formHeader.get('nroDoc').dirty ||
                                    formHeader.get('nroDoc').touched)
                                    ">
                                    <mdb-error *ngIf="formHeader.get('nroDoc').hasError('required')">
                                        Ingrese n° documento
                                    </mdb-error>
                                </div> -->
              </div>
            </div>
            <div class="col" style="max-width: 200px">
              <Strong class="title">F. Guía de despacho</Strong>
              <div class="md-form m-0">
                <mdb-date-picker #dpFechaDetalle [inline]="true" name="fechaDesde" [placeholder]="'F. Detalle'" required
                  formControlName="fechaDetalle">
                </mdb-date-picker>
                <div *ngIf="
                                    formHeader.get('fechaDetalle').invalid &&
                                    (formHeader.get('fechaDetalle').dirty ||
                                    formHeader.get('fechaDetalle').touched)
                                    ">
                  <mdb-error *ngIf="formHeader.get('fechaDetalle').hasError('required')">
                    Ingrese fecha
                  </mdb-error>
                </div>
              </div>
            </div>
          </div>


          <div class="row mt-2">
            <div class="col">
              <div class="md-form mb-0">
                <h5 class="mt-2" style="border-bottom: 1px solid #dee2e6">
                  Garantía
                </h5>

              </div>
            </div>
          </div>
          <div class="row">
            <div class="col" style="max-width: 300px">
              <div class="md-form">
                <mdb-select [options]="optionsTipoDocGarantia" [multiple]="false" [filterEnabled]="true"
                  [highlightFirst]="false" placeholder="Seleccionar tipo" formControlName="tipoDteGar">
                </mdb-select>
                <label>Tipo de documento</label>

              </div>
            </div>
            <div class="col" style="max-width: 300px">
              <div class="md-form">
                <input value="" type="text" id="ndoc" class="form-control" placeholder="N° Documento" #ndoc
                  formControlName="nroDocGar" onlyNumbers />
                <label for="ndoc">N° Documento</label>

              </div>
            </div>
            <div class="col" style="max-width: 200px">
              <Strong class="title">F. Garantía</Strong>
              <div class="md-form m-0">
                <mdb-date-picker [inline]="true" name="fechaDesdeGar" [placeholder]="'F. Garantía'" required
                  formControlName="fechaDesdeGar">
                </mdb-date-picker>

              </div>
            </div>
          </div>

          <h5 class="mt-2" style="border-bottom: 1px solid #dee2e6">
            <mdb-checkbox formControlName="contrato">
              <span style="font-size: 1rem">Contrato</span>
            </mdb-checkbox>
          </h5>

          <div class="row" *ngIf="mostrarFilasContrato">
            <div class="col" style="max-width: 300px">
              <div class="md-form mt-4">
                <input value="" type="text" id="ncontrato" class="form-control" placeholder="N° Contrato" #ncontrato
                  formControlName="nroContratoGar" onlyNumbers />
                <label for="ncontrato">N° Contrato</label>
              </div>
            </div>
            <div class="col" style="max-width: 200px">
              <Strong class="title">F. Contrato</Strong>
              <div class="md-form m-0">
                <mdb-date-picker [inline]="true" name="fechaDocGar" [placeholder]="'Fecha Doc.'" required
                  formControlName="fechaDocGar">
                </mdb-date-picker>
              </div>
            </div>
            <div class="col" style="max-width: 200px">
              <Strong class="title">Vigencia desde</Strong>
              <div class="md-form m-0">
                <mdb-date-picker [inline]="true" name="vigDesde" [placeholder]="'Vigencia desde'"
                  formControlName="fechaVigenciaDesdeGar">
                </mdb-date-picker>
              </div>
            </div>
            <div class="col" style="max-width: 200px">
              <Strong class="title">Vigencia hasta</Strong>
              <div class="md-form m-0">
                <mdb-date-picker [inline]="true" name="vigHasta" [placeholder]="'Vigencia hasta'"
                  formControlName="fechaVigenciaHastaGar">
                </mdb-date-picker>
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col">
              <div class="md-form mb-0">
                <h5 class="mt-2" style="border-bottom: 1px solid #dee2e6">
                  Entrega
                </h5>

              </div>
            </div>
          </div>

          <div class="row align-items-center">
            <div class="col" style="max-width: 200px">
              <Strong class="title">F. Entrega</Strong>
              <div class="md-form m-0">
                <mdb-date-picker [inline]="true" name="vigHasta" [placeholder]="'F. Entrega'" required
                  formControlName="fechaConfirmacionEntrega">
                </mdb-date-picker>
                <div *ngIf="
                      formHeader.get('fechaConfirmacionEntrega').invalid &&
                      (formHeader.get('fechaConfirmacionEntrega').dirty ||
                      formHeader.get('fechaConfirmacionEntrega').touched)
                    ">
                  <mdb-error *ngIf="formHeader.get('fechaConfirmacionEntrega').hasError('required')">
                    Ingrese fecha confirmación
                  </mdb-error>
                </div>
              </div>
            </div>
            <div class="col">
              <mdb-checkbox [checked]="false" formControlName="esMovimientoCerrado">Movimiento cerrado</mdb-checkbox>
            </div>
          </div>

        </div>
      </form>
      <div class="modal-footer justify-content-between">
        <button size="sm" type="button" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
          (click)="addEditMaquina.hide()" mdbWavesEffect>
          Cerrar
        </button>
        <button size="sm" type="button" class="btn btn-sm btn-secondary waves-light" mdbWavesEffect (click)="guardar()">
          Guardar
        </button>
      </div>
    </div>
  </div>
</div>

<!-- MODAL seleccionarProveedor -->
<app-modal-seleccionar-proveedor (onSelect)="onProveedorSeleccionado($event)" [showFiltroActivoInactivo]="false"
  (onNotFound)="onProductoNoEncontrado()">
</app-modal-seleccionar-proveedor>
